var map = {
	"./activeBag.svg": 19453,
	"./activeBrief.svg": 16131,
	"./activeCard.svg": 65875,
	"./activeConcession.svg": 26701,
	"./activeDash.svg": 63089,
	"./activeDepot.svg": 27837,
	"./activeDepot1.svg": 33398,
	"./activeRefund.svg": 85599,
	"./activeSupport.svg": 78230,
	"./activeTankTruck.svg": 84290,
	"./activeTruck.svg": 94374,
	"./activeUser.svg": 18668,
	"./activeUserGroup.svg": 68173,
	"./activeWallet.svg": 99238,
	"./activecardmanagement.svg": 98598,
	"./activeconcession1.svg": 78598,
	"./activedealer.svg": 48694,
	"./activedrystock order.svg": 22302,
	"./activeinventory.svg": 59003,
	"./activepaymentinflow.svg": 71504,
	"./activeprogram.svg": 90283,
	"./activerefundrequest.svg": 41838,
	"./activesettings& control.svg": 99331,
	"./activeteams.svg": 61157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74435;